module.exports = __webpack_public_path__ + "static/img/homeBotBg.552715fd.png";